// frontend-crm/src/pages/Dashboard.js
import React, { useEffect, useState } from 'react';
import { Grid, Paper, Typography, Box, Card, CardContent } from '@mui/material';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useQuery } from 'react-query';
import { socket } from '../App';

const fetchStats = async () => {
  const res = await fetch('/api/admin/stats', {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });
  return res.json();
};

export default function Dashboard() {
  const { data: stats } = useQuery('stats', fetchStats, { refetchInterval: 30000 });
  const [pedidosActivos, setPedidosActivos] = useState([]);
  const [mensajerosOnline, setMensajerosOnline] = useState(0);

  useEffect(() => {
    socket.on('pedido-nuevo', (pedido) => {
      setPedidosActivos(prev => [pedido, ...prev]);
    });
    
    socket.on('location-update', (data) => {
      // Actualizar posición en mapa
    });

    return () => {
      socket.off('pedido-nuevo');
      socket.off('location-update');
    };
  }, []);

  return (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Typography variant="h4" gutterBottom>Panel de Control</Typography>
      
      <Grid container spacing={3}>
        {/* KPIs */}
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary">Pedidos Hoy</Typography>
              <Typography variant="h3">{stats?.data?.pedidos_hoy || 0}</Typography>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary">En Curso</Typography>
              <Typography variant="h3">{stats?.data?.en_curso || 0}</Typography>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary">Mensajeros Online</Typography>
              <Typography variant="h3">{stats?.data?.mensajeros_online || 0}</Typography>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography color="textSecondary">Ingresos Hoy</Typography>
              <Typography variant="h3">${stats?.data?.ingresos_hoy || 0}</Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Gráfico de Ingresos */}
        <Grid item xs={12} md={8}>
          <Paper sx={{ p: 2, height: 400 }}>
            <Typography variant="h6" gutterBottom>Ingresos Semanales</Typography>
            <ResponsiveContainer width="100%" height="90%">
              <LineChart data={stats?.data?.grafico_data || []}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="dia" />
                <YAxis />
                <Tooltip />
                <Line type="monotone" dataKey="ingresos" stroke="#1976d2" />
              </LineChart>
            </ResponsiveContainer>
          </Paper>
        </Grid>

        {/* Pedidos en Tiempo Real */}
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2, height: 400, overflow: 'auto' }}>
            <Typography variant="h6" gutterBottom>Actividad Reciente</Typography>
            {pedidosActivos.map((pedido, idx) => (
              <Box key={idx} sx={{ mb: 2, p: 1, bgcolor: 'grey.100', borderRadius: 1 }}>
                <Typography variant="subtitle2">Pedido #{pedido.id}</Typography>
                <Typography variant="body2" color="textSecondary">
                  {pedido.origen_direccion} → {pedido.destino_direccion}
                </Typography>
                <Typography variant="caption" color="primary">{pedido.estado}</Typography>
              </Box>
            ))}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}